import axios from 'axios'
import {
  $message,
  Message,
  MessageBox
} from 'element-ui'

export default  {

  postData(url, data, success) {
    var that = this;

    axios.post('/api/'+ url , data)
      .then(function (res) {

        // console.log('url：',url);
        // console.log('data：',data);
        // console.log('tool返回数据：',res.data);

        /** 成功 : 1 **/
        if (res.data.result.code == 200) {
          success && success(res);
        }
        /** 失败 : 0/3 **/
        else {
          Message({
            showClose:true,
            message:res.data.result.message,
            type: 'error'
          })
        }

      })
      .catch(function (error) {
        console.log(error);
      });

  },

}



// WEBPACK FOOTER //
// ./src/assets/js/tool.js